import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect, useRef, useContext } from 'react';
import ExpertProductApi from '../../../api/ExpertProductApi';
import ExpertConnectionPop from "../../popup/ExpertConnectionPop";
import UserContext from "../../../context/UserContext";
import { loginAlert } from "../../common/CustomAlert";
import { resolveProfileImg } from '../../../util/ProfileUtil';

const FaqItem = ({ faq }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <li>
            <div className={`service-qna-head${isOpen ? ' active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
                <p>{faq.faq_question}</p>
                <i className={`icon icon-arrow-down`}></i>
            </div>
            {isOpen && (
                <div style={{transition: 'height 300ms', height: 'auto'}}>
                    <div className="service-qna-answer">
                        <p>{faq.faq_answer}</p>
                    </div>
                </div>
            )}
        </li>
    )
}

const TermItem = ({ term, tab4Ref }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="service-detail-row" data-tab-pannel="tab4" ref={tab4Ref}>
            <div className={`service-term-title${isOpen ? ' active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
                <p>취소 및 환불 규정</p>
                <i className={`icon icon-arrow-down`}></i>
            </div>
            {isOpen && (
                <div>
                    {term ? (
                        <pre>{term}</pre>
                    ) : (
                        <pre>취소 및 환불 규정이 없습니다.</pre>
                    )}
                </div>
            )}  
        </div>
    )
}

const ExportProduct = () => {
    const navigate = useNavigate();
    const { user } = useContext(UserContext);
    const { productId } = useParams();
    const [product, setProduct] = useState(null);
    const [services, setServices] = useState([]);
    const [faqs, setFaqs] = useState([]);
    const [term, setTerm] = useState(null);
    const [documentData, setDocumentData] = useState(null);
    const [activeTab, setActiveTab] = useState('tab1');
    const [expertConnectionPopOpen, setExpertConnectionPopOpen] = useState(false);
    
    const tab1Ref = useRef(null);
    const tab2Ref = useRef(null);
    const tab3Ref = useRef(null);
    const tab4Ref = useRef(null);

    const handleExpertProfileClick = expertOWnerId => {
        navigate("/expert/detail/" + expertOWnerId);
    }

    const handleInquiryClick = () => {
        if (!user?.userId) return loginAlert('로그인이 필요합니다.');
        setExpertConnectionPopOpen(true);
    }

    const handleTabClick = (tabId) => {
        const targetRef = {
            'tab1': tab1Ref,
            'tab2': tab2Ref,
            'tab3': tab3Ref,
            'tab4': tab4Ref
        }[tabId];
        
        if (targetRef?.current) {
            const header = document.querySelector('.vh-header-wrap');
            const headerHeight = header ? header.offsetHeight+70 : 0;
            const targetPosition = targetRef.current.offsetTop + window.scrollY - headerHeight;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    }

    const handleLikeClick = async (e) => {
        e.preventDefault();
        const result = await ExpertProductApi.toggleLike(productId);
        if (result && result.is_liked !== undefined) {
            const newProduct = {...product};
            newProduct.liked_by_me = result.is_liked;
            if (!newProduct.expert_product_like_cnt) newProduct.expert_product_like_cnt = 0;
            result.is_liked ? newProduct.expert_product_like_cnt++ : newProduct.expert_product_like_cnt--;
            setProduct(newProduct);
        }
    }

    useEffect(() => {
        if (!productId) return;
        ExpertProductApi.getExpertProduct(productId, true).then(data => {
            if (!data) return;
            setProduct(data.product || null);
            setServices(data.services || []);
            setFaqs(data.faqs || []);
            setTerm(data.term || null);
            setDocumentData(data.document || null);
        })
    }, [productId])

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + 100; // offset for better UX
            
            const sections = [
                { id: 'tab1', ref: tab1Ref },
                { id: 'tab2', ref: tab2Ref },
                { id: 'tab3', ref: tab3Ref },
                { id: 'tab4', ref: tab4Ref }
            ];

            for (let i = sections.length - 1; i >= 0; i--) {
                const section = sections[i];
                if (section.ref.current && section.ref.current.offsetTop <= scrollPosition) {
                    setActiveTab(section.id);
                    break;
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [])



    return (
        <>
            <div className="service-detail-area">
                <div className="service-detail-header">
                    <div className="service-profile">
                        <div className="service-profile-top">
                            <p>서비스 정보</p>
                            <div className="service-profile-right">
                                <div className="etc">
                                    <i className={`icon icon-heart${product?.liked_by_me ? '-fill' : ''}`}
                                       style={{cursor: 'pointer'}}
                                       onClick={handleLikeClick}
                                    ></i>
                                    <span>{product?.expert_product_like_cnt ?? 0}</span>
                                </div>
                            </div>
                        </div>
                        <h1 className="service-detail-subject">{product?.expert_product_title || ''}</h1>
                        <div className="expert-profile-area">
                            <div className="expert-profile" style={{cursor: "pointer"}} onClick={() => handleExpertProfileClick(product?.expert_product_owenr_id)}>
                                <div className="thumb">
                                    <img src={resolveProfileImg(product?.user_profile_img, product?.expert_product_owenr_id)} />
                                </div>
                                <p>{product?.user_nicknm || ''}</p>
                            </div>
                            <button type="button" className="btn btn-primary" onClick={handleInquiryClick}>
                                <span>문의하기</span>
                            </button>
                        </div>
                    </div>
                    <a className="service-detail-banner">
                        <img src={product?.expert_product_banner_img || "/static/img/assets/thumb_adv.png"} />
                    </a>
                </div>
                <div className="service-detail-tablist">
                    <ul>
                        <li 
                            className={activeTab === 'tab1' ? 'active' : ''} 
                            onClick={() => handleTabClick('tab1')}
                        >
                            가격 정보
                        </li>
                        <li 
                            className={activeTab === 'tab2' ? 'active' : ''} 
                            onClick={() => handleTabClick('tab2')}
                        >
                            상세 설명
                        </li>
                        <li 
                            className={activeTab === 'tab3' ? 'active' : ''} 
                            onClick={() => handleTabClick('tab3')}
                        >
                            질문답변
                        </li>
                        <li 
                            className={activeTab === 'tab4' ? 'active' : ''} 
                            onClick={() => handleTabClick('tab4')}
                        >
                            취소환불
                        </li>
                    </ul>
                </div>
                <div className="service-detail">
                    <div className="service-detail-row" data-tab-pannel="tab1" ref={tab1Ref}>
                        <div className="service-detail-tit">가격 정보</div>
                        <ul className="service-product-list">
                            {services.map(svc => (
                                <li key={svc.service_id}>
                                    <p>{svc.service_name}</p>
                                    <p>{Number(svc.service_price).toLocaleString()}원</p>
                                </li>
                            ))}
                            {services.length === 0 && (
                                <li>
                                    <p>등록된 서비스가 없습니다.</p>
                                    <p>-</p>
                                </li>
                            )}
                        </ul>
                    </div>
                    <div className="service-detail-row" data-tab-pannel="tab2" ref={tab2Ref}>
                        <div className="service-detail-tit">상세 설명</div>
                        {documentData?.content ? (
                            <div className="service-detail-content description ck-editor-content" dangerouslySetInnerHTML={{ __html: documentData.content }}></div>
                        ) : (
                            <div className="service-detail-content description">
                                <p>상세 설명이 없습니다.</p>
                            </div>
                        )}
                    </div>
                    <div className="service-detail-row" data-tab-pannel="tab3" ref={tab3Ref}>
                        <div className="service-detail-tit">자주 묻는 질문</div>
                        <ul className="service-qna-list">
                            {faqs.map(fq => <FaqItem key={fq.faq_id} faq={fq} />)}
                            {faqs.length === 0 && (
                                <li>
                                    <div className="service-qna-head">
                                        <p>등록된 질문이 없습니다.</p>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>
                    <TermItem term={term?.term_content} tab4Ref={tab4Ref} />     
                </div>
            </div>
            { expertConnectionPopOpen && 
                <ExpertConnectionPop 
                    ownerId={product.expert_product_owenr_id} 
                    onClose={() => setExpertConnectionPopOpen(false)}
                />
            }
        </>
    )
}

export default ExportProduct;